import type { z } from 'zod';

import { ContractError } from './errors';

export const parseOrThrow = <S extends z.ZodTypeAny>(schema: S, raw: unknown, label: string): z.infer<S> => {
  const result = schema.safeParse(raw);
  if (!result.success) throw new ContractError(`Unexpected ${label} response shape`, result.error.issues);
  return result.data;
};
